export default "__VITE_ASSET__C$JoAXLG__"